module.exports = __webpack_public_path__ + "img/venuethree-zrw.2d41baba.png";